import { css } from 'styled-components';

export const hideLabel = css`
  label {
    display: none;
  }
`;

export const offsetCancelButton = css`
  margin-top: 0.3rem;
`;
